export enum enumAssignmentStatus {
    PENDING = 1,
    ACCEPTED = 2,
    REJECTED = 3,
    REVOKED = 4,
}